export default {
  settings: 'Ustawienia',
  storefront: 'Sklep',
  media: 'Media',
  style: 'Styl',
  scripts: 'Skrypty',
  no_google_place: {
    title: 'Firma nie jest połączona z żadną lokalizacją Google',
    description: 'Połącz firmę z lokalizacją Google',
  },
};
